import React from 'react';
import styled from 'styled-components';

import ScrollingBanner from 'ScrollingBanner';

import icon1 from './assets/icon1.svg';
import icon2 from './assets/icon2.svg';
import icon3 from './assets/icon3.svg';
import logo from './assets/logo.svg';

const mobile = '@media screen and (orientation:portrait)';

const Root = styled.div`
	position: relative;
	background-color: #000;
	width: 100vw;
	height: 100vh;
	overflow: auto;
	${mobile}{
		height: auto;
	}
`;

const Headline = styled.h1`
	color: #FF001A;
	font-size: ${150/1024*100}vh;
	line-height: ${180/150};
	margin-left: ${24/150}em;
	margin-top: ${25/150}em;
	font-weight: bold;
	text-transform: uppercase;
	user-select: none;

	font-size: ${150/1024*100}vh;
	line-height: ${180/150};
	margin-left: ${24/150}em;
	margin-top: ${25/150}em;
	text-align: left;
	${mobile}{
		width: 100vw;
		font-size: ${91/414*100}vw;
		line-height: ${109/91};
		margin-left: 0;
		margin-top: ${21/91}em;
		text-align: center;
	}

	span{
		display: inline-block;
		width: auto;
		position: relative;
	}
	span:after{
		content: ' ';
		display: inline-block;
		position: absolute;
		bottom: .0685em;
		left: 0.05em;
		width: calc(100% - 0.1em);
		height: 0.125em;
		border-radius: 0.030em;
		background-color: #FF001A;
	}
`;

const Icon = styled(({className,src})=>(
	<img alt="" src={src} className={className}/>
))`
	margin-left: auto;
	margin-right: auto;
	vertical-align: top;
	&:first-child{
		float: left;
	}
	&:last-child{
		float: right;
	}
`;

const Icons = styled.div`
	text-align: center;
	position: absolute;

	& > img{
		height: 100%;
	}

	width: ${323/1024*100}vh;
	height: ${55/1024*100}vh;
	left: ${30/1024*100}vh;
	bottom: ${25/1024*100}vh;
	${mobile}{
		position: relative;
		height: ${19/414*100}vw;
		width: ${114/414*100}vw;
		left: 0;
		bottom: 0;
		margin-left: ${(100 - (114/414*100))/2}vw;
		margin-bottom: ${138/414*100}vw;
	}
`;

const Coordinates = styled.div`
	color: #FF001A;
	font-size: ${15/1024*100}vh;
	letter-spacing: ${11.5/15}em;
	font-weight: bold;

	position: absolute;
	right: ${148/1024*100}vh;
	bottom: ${34/1024*100}vh;


	${mobile}{
		text-align: center;
		width: 100vw;
		left: 0;
		bottom: ${92/414*100}vw;
		font-size: ${11.5/414*100}vw;
		letter-spacing: ${9.93/11.5}em;
	}
`;

const ComingSoon = ()=>(
	<Headline>
		<span>inking</span><br/>
		<span>soon</span>
	</Headline>
);

const Logo = styled.img`
	width: ${792/1024*100}vh;
	margin-left: ${30/1024*100}vh;
	margin-top: ${36/1024*100}vh;
	${mobile}{
		width: ${350/414*100}vw;
		margin-left: calc((100vw - ${350/414*100}vw)/2);
		margin-top: ${32/414*100}vw;
	}
`;
const BrMobile = styled.br`
	display: none;
`;
const Poem = styled.div`
	line-height: ${19/16};
	color: #FF001A;
	font-weight: bold;
	& p{
		margin-bottom: 1em;
	}

	font-size: ${16/1024*100}vh;
	margin-top: ${96/1024*100}vh;
	margin-left: ${147/1024*100}vh;
	max-width: 27em;

	${mobile}{
		font-size: ${16/414*100}vw;
		margin-top: ${51/414*100}vw;
		margin-bottom: ${30/414*100}vw;
		margin-left: ${(100 - 300/414*100)/2}vw;
		max-width: 18.5em;
		& ${BrMobile}{
			display: initial;
		}
	}

`;

// 1440x1024
// 792x219 (30,36)
// 440x468 (147,351)
// #FF001A
// 16/19 px BOLD

// 414x1011
// 350x97 (32,141)
// 302x567 (56,289)
// #FF001A
// 16/19 px BOLD

export default function Base({className}){
	return (
		<Root className={className}>
			<Logo src={logo} />
			<Poem>
				<p>Everyone’s asking the wrong question.</p>

				<p>
					It was never about knowing what art is. Because defining
					something gives us the illusion of control over that thing. And
					we don’t want to control art, we just want to know where it is.
				</p>

				<p>
					Where art is made.<br/>
					Where art is respected.<br/>
					Where art has space to grow.
				</p>

				<p>And where art finds a place to stay.</p>

				<p>
					We believe in these places. These righteous places. They’re
					not utopias once you recognize art is moving forward on its
					own and that our only duty is to be a beacon for it.
				</p>

				<p>
					So we welcome artists from all over the world and we respect
					their identity and craft.
				</p>

				<p>
					So we educate and learn together.<br/>
					So we look to the future and stay ahead.<br/>
					So we ink it with purpose.
				</p>

				<p>Because there’s a place where <BrMobile/>art has a heart.</p>
			</Poem>
			<Icons>
				<Icon src={icon1} />
				<Icon src={icon2} />
				<Icon src={icon3} />
			</Icons>
			<Coordinates>
				<a href="https://g.page/ravenunlimitedart" target="_blank" rel="noopener noreferrer">
					41°16'41.7"N 8°22'10.6"W
				</a>
			</Coordinates>
			<ScrollingBanner/>
		</Root>
	);
};
